import React from 'react'
import Button from 'components/Shared/Button'
import { SHEETBRIDGE_URL } from 'config'

import { LOADING, FAILURE } from './useSheetBridgeFlow'

export const SheetBridgeAuthStep = ({
  checkingAuth,
  authState,
  noBridges,
  onGetBridges,
}) => {
  return (
    <div className="sheetbridge-auth-step">
      <h2>Connect to SheetBridge</h2>
      <p>
        Connect your Google Sheets to SheetBridge and create instant API
        endpoints for your Adalo app.
      </p>
      {checkingAuth ? (
        <div className="checking-auth">
          <p>Checking account status...</p>
        </div>
      ) : (
        <>
          {noBridges && (
            <div className="error-message">
              No bridges found for this account. Please create a SheetBridge
              account or add bridges, then try again.
            </div>
          )}
          <div className="auth-buttons">
            <Button
              teal
              onClick={onGetBridges}
              loading={authState === LOADING}
              disabled={authState === LOADING}
            >
              Get My Bridges
            </Button>
            <p className="have-account-text">
              Don't have an account?{' '}
              <a
                href={SHEETBRIDGE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="signup-link"
              >
                Sign up to SheetBridge
              </a>
            </p>
          </div>
          {authState === FAILURE && (
            <div className="error-message">
              Failed to connect. Please try again.
            </div>
          )}
        </>
      )}
    </div>
  )
}
